import { Dom7 as $ } from "framework7/bundle";
import { readItem } from "./storage.js";
import { logout } from "./auth.js";
import { requireAuth, isLoggedIn } from "./session.js";
import { adjustScreen } from "./ui.js";

// Geschuetzte Routen tragen `beforeEnter: requireAuth` (session.js); die
// Seiten selbst pruefen den Login nicht mehr.
// Seiten und Panels liegen in public/ und werden zur Laufzeit geladen.
// Pfade absolut, damit sie auch auf einem Deep Link (/patient/therapy/1/2/)
// aufgeloest werden.
const routes = [

  {
    path: '/',
    name: 'onboarding-intro',
    componentUrl: '/pages/onboarding/intro.html',
    on: {
      pageBeforeIn: function (event, page) {
        if (isLoggedIn()) {
          //Check if Logged in / known user
          page.router.navigate('/dashboard/');
        }

        if ((readItem('language_set', 'localStorage') != '')) {
          //Check if Logged in / known user
          page.router.navigate('/onboarding/welcome/');
        }

      }
    }

  },
  {
    path: '/onboarding/language/',
    name: 'onboarding-language',
    componentUrl: '/pages/onboarding/language.html',
  },
  {
    path: '/onboarding/welcome/',
    name: 'onboardingWelcome',
    componentUrl: '/pages/onboarding/welcome.html',
  },
  {
    path: '/onboarding/invitation/',
    name: 'onboardingInvitation',
    componentUrl: '/pages/onboarding/invitation.html',
  },
  {
    path: '/onboarding/createaccountAGB/',
    name: 'onboardingCreateAccountAGB',
    componentUrl: '/pages/onboarding/createAccount-agb.html',
  },
  {
    path: '/onboarding/setpassword/',
    name: 'onboardingCreateAccountPassword',
    componentUrl: '/pages/onboarding/createAccount-password.html',
  },
  {
    path: '/onboarding/setpin/',
    name: 'onboardingCreateAccountPin',
    componentUrl: '/pages/onboarding/createAccount-pin.html',
  },
  {
    path: '/onboarding/setavatar/',
    name: 'onboardingCreateAccountAvatar',
    componentUrl: '/pages/onboarding/createAccount-avatar.html',
  },
  {
    path: '/onboarding/setskin/',
    name: 'onboardingCreateAccountSkin',
    componentUrl: '/pages/onboarding/createAccount-skin.html',
  },
  {
    path: '/onboarding/done/',
    name: 'onboardingCreateAccountDone',
    componentUrl: '/pages/onboarding/createAccount-done.html',
  },
  {
    path: '/onboarding/login/',
    name: 'onboarding-login',
    componentUrl: '/pages/onboarding/login.html',
  },
  {
    path: '/onboarding/resetpw/',
    name: 'onboarding-resetpw',
    componentUrl: '/pages/onboarding/pwreset.html',
  },
  {
    path: '/onboarding/resetpw/setpassword/',
    name: 'pwresetPassword',
    componentUrl: '/pages/onboarding/pwreset-password.html',
  },
  {
    path: '/onboarding/resetpw/done/',
    name: 'pwresetDone',
    componentUrl: '/pages/onboarding/pwreset-done.html',
  },
  {
    path: '/onboarding/resetpw/pincode/',
    name: 'pwresetPincode',
    componentUrl: '/pages/onboarding/pwreset-pincode.html',
    on: {
      pageBeforeIn: function (event, page) {
        $('#pincodeFrmPin1').focus();
      }
    }
  },
  {
    path: '/onboarding/pincode/',
    name: 'onboarding-pincode',
    componentUrl: '/pages/onboarding/pincode.html',
    on: {
      pageBeforeIn: function (event, page) {
        $('#pincodeFrmPin1').focus();
      }
    }
  },
  {
    path: '/onboarding/signup/',
    name: 'onboarding-signup',
    url: '/pages/onboarding/signup.html',
  },
  {
    path: '/dashboard/',
    beforeEnter: requireAuth,
    componentUrl: '/pages/patient/dashboard.html',
    name: 'dashboard',
  },
  {
    path: '/patient/therapy/:therapyId/:sessionId/',
    beforeEnter: requireAuth,
    name: 'patient-therapy',
    componentUrl: '/pages/patient/therapy.html',
    options: {
      transition: 'f7-dive',
    },
  },
  {
    path: '/therapy/chapters/:therapyId/:sessionId/:stepId/',
    beforeEnter: requireAuth,
    name: 'therapy-chapters',
    componentUrl: '/pages/therapy/chapters.html',
  },
  {
    path: '/therapy/start/:therapyId/:sessionId/:stepId/',
    beforeEnter: requireAuth,
    name: 'therapy-start',
    componentUrl: '/pages/therapy/start.html',
    options: {
      transition: 'f7-dive',
    },
  },
  {
    path: '/exercise/start/:therapyId/',
    beforeEnter: requireAuth,
    name: 'exercise-start',
    componentUrl: '/pages/exercise/start.html',
  },
  {
    path: '/checkin/start/:therapyId/',
    beforeEnter: requireAuth,
    name: 'checkin-start',
    componentUrl: '/pages/checkin/start.html',
  },

  {
    path: '/panels/main/',
    beforeEnter: requireAuth,
    name: 'main-menu',
    componentUrl: '/panels/panel-main.html',
    options: {
      transition: 'f7-flip',
    },
  },
  {
    path: '/panels/exercise-result/:therapyId/:activityId/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-exercise-result.html',
    },
  },
  {
    path: '/panels/activity/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-activity.html',
    },
  },
  {
    path: '/panels/emergency-plan/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-emergency-plan.html',
    },
  },
  {
    path: '/panels/contacts/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-contacts.html',
    },
  },
  {
    path: '/panels/exercises/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-exercises.html',
    },
  },
  {
    path: '/panels/notes/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-notes.html',
    },
  },
  {
    path: '/panels/messages/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-messages.html',
    },
  },
  {
    path: '/panels/settings/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-settings.html',
    },
  },
  {
    path: '/panels/settings/terms/',
    beforeEnter: requireAuth,
    name: 'settings-terms',
    componentUrl: '/panels/panel-settings-terms.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/faq/',
    beforeEnter: requireAuth,
    name: 'settings-faq',
    componentUrl: '/panels/panel-settings-faq.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/privacy/',
    beforeEnter: requireAuth,
    name: 'settings-privacy',
    componentUrl: '/panels/panel-settings-privacy.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/account/',
    beforeEnter: requireAuth,
    name: 'settings-account',
    componentUrl: '/panels/panel-settings-account.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/notifications/',
    beforeEnter: requireAuth,
    name: 'settings-notifications',
    componentUrl: '/panels/panel-settings-notifications.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/reminders/',
    beforeEnter: requireAuth,
    name: 'settings-reminders',
    componentUrl: '/panels/panel-settings-reminders.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/password/',
    beforeEnter: requireAuth,
    name: 'settings-password',
    componentUrl: '/panels/panel-settings-password.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/app-settings/',
    beforeEnter: requireAuth,
    name: 'settings-app-settings',
    componentUrl: '/panels/panel-settings-app-settings.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/settings/contacts/',
    beforeEnter: requireAuth,
    name: 'settings-app-contacts',
    componentUrl: '/panels/panel-settings-contacts.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/panels/documents/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-documents.html',
    },
  },
  {
    path: '/panels/therapy/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-therapy.html',
    },
  },
  {
    path: '/panels/sos/',
    beforeEnter: requireAuth,
    panel: {
      componentUrl: '/panels/panel-sos.html',
    },
  },
  {
    path: '/panels/sos/:locationId/',
    beforeEnter: requireAuth,
    name: 'sos-detail',
    componentUrl: '/panels/panel-sos-detail.html',
    on: {
      pageAfterIn: function (event, page) {
        adjustScreen();
      }
    }
  },
  {
    path: '/logout/',
    name: 'logout-path',
    url: '/pages/onboarding/welcome.html',
    on: {
      pageBeforeIn: function (event, page) {
        logout();
      }
    },
  },

  // Default route (404 page). MUST BE THE LAST
  {
    path: '(.*)',
    url: '/pages/404.html',
  },
];

export default routes;
